import { Instagram, Youtube } from 'lucide-react';
import { SiFacebook, SiTiktok } from 'react-icons/si';

export const QUEUE_ACCOUNT_PLATFORMS = [
  { platform: 'instagram', label: 'Instagram', icon: <Instagram className="h-5 w-5 text-pink-500" aria-hidden="true" /> },
  { platform: 'facebook', label: 'Facebook', icon: <SiFacebook className="h-4 w-4 text-blue-500" aria-hidden="true" /> },
  { platform: 'tiktok', label: 'TikTok', icon: <SiTiktok className="h-4 w-4 text-foreground" aria-hidden="true" /> },
  { platform: 'youtube', label: 'YouTube', icon: <Youtube className="h-5 w-5 text-red-500" aria-hidden="true" /> },
] as const;
